module.exports = __webpack_public_path__ + "static/media/no-connection.85d7c8a1.svg";